/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */
/* global console, document, Excel, Office */

// The initialize function must be run each time a new page is loaded

Office.onReady(() => {
  // document.getElementById("sideload-msg").style.display = "none";
  // document.getElementById("app-body").style.display = "flex";
  document.getElementById("refresh").onclick = run;
});

export async function run() {
  try {
    await Excel.run(async (context) => {
      const range = context.workbook.getSelectedRange();
      const sheet = context.workbook.worksheets.getActiveWorksheet();
      localStorage.setItem('countPerSecond', '0');
      sheet.calculate(true);
      await context.sync();
    });
  } catch (error) {
    console.error(error);
  }
}
